import { OptionsObject, SnackbarMessage, useSnackbar } from "notistack";

export interface GlobalMessage {
  message: SnackbarMessage;
  options?: OptionsObject;
}

export default function useGlobalMessage() {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const show = (message: GlobalMessage) => {
    return enqueueSnackbar(message.message, {
      ...(message.options ?? {}),
      variant: message.options?.variant ?? "success",
    });
  };

  const close = (key?: string | number) => {
    closeSnackbar(key);
  };

  return { show, close } as const;
}
